// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"05454bcb","513":"55888b5b","703":"5152d7f2","787":"9f29a76c"}[chunkId] + ".chunk.js";
};